module.exports = __webpack_public_path__ + "img/paytype-wx.28904cd4.png";